import { Day } from "./Consts";

export class BookingData
{
	private readonly _now: Date;
	private readonly _bookedFullTimes: number[];
	private readonly _bookedCheckInTimes: number[];
	private readonly _bookedCheckOutTimes: number[];

	constructor(bookingItems: IBookingItem[])
	{
		this._now = new Date();

		this._bookedFullTimes = [];
		this._bookedCheckInTimes = [];
		this._bookedCheckOutTimes = [];

		for (const item of bookingItems)
		{
			const date = this.getDateFrom(item.from);
			const startTime = date.getTime();
			this._bookedCheckInTimes.push(startTime);

			let time = date.getTime();
			const endDate = this.getDateFrom(item.to);
			const endTime = endDate.getTime();

			while(true)
			{
				date.setDate(date.getDate() + 1);
				time = date.getTime();

				if (time < endTime)
				{
					this._bookedFullTimes.push(time);
				}
				else
				{
					this._bookedCheckOutTimes.push(endTime);
					break;
				}
			}
		}
	}

	public isInPast(y: number, m: number, d: number): boolean
	{
		return this._now.getFullYear() >= y && this._now.getMonth() >= m && this._now.getDate() > d;
	}

	public isBookedCheckIn(time: number): boolean
	{
		return this._bookedCheckInTimes.includes(time);
	}

	public isBookedCheckOut(time: number): boolean
	{
		return this._bookedCheckOutTimes.includes(time);
	}

	public isBookedFull(time: number): boolean
	{
		return (this._bookedCheckInTimes.includes(time) && this._bookedCheckOutTimes.includes(time)) || this._bookedFullTimes.includes(time);
	}

	private getDateFrom(val: string): Date
	{
		const parts = val.split("-");
		const y = +parts[0];
		const m = +parts[1] - 1;
		const date = +parts[2];

		return new Date(y, m, date);
	}
}

export interface IBookingItem
{
	// YYYY-MM-DD, ISO 8601 format
	from: string;
	to: string;
}

export interface IBookingOptions
{
	locale?: string;
	firstDayId?: number;
	dayIds?: Day[];
}
